import React from 'react';
import './TruckImageSection.scss';
import { useAnimateOnScroll } from '../../Utils/hooks/useAnimateOnScroll';

import truckImage from '../../Assets/images/truck_image_section.png';

const TruckImageSection = () => {
  const sectionRef = useAnimateOnScroll();

  return (
    <section ref={sectionRef} className="truck-image-section scale-in">
      <img
        src={truckImage}
        alt="Heavy duty dump truck at night"
        className="truck-image-section__img"
      />
    </section>
  );
};

export default TruckImageSection;
